export const environment = {
	production: false,
	apiServer: 'https://api.qa.tk.omniflou.com',
	adminUrl: 'https://admin.qa.tk.omniflou.com',
	agentUrl: 'https://agent.qa.tk.omniflou.com',
	easyUrl: 'https://easy.qa.tk.omniflou.com/conditions',
	wsServer: 'https://ws.qa.tk.omniflou.com/videolink',
	storage: 'https://cdn.qa.tk.in.omniflou.com',
	vlTokenSupport: '8b856fee2b4bdaa534c869092584cd4564a1a59c123b9a20a96b51178d132729',
	urlCdnContent: 'https://cdn.tk.qa.omniflou.com/autoload.js',
	cdnFiles: 'https://cdn.tk.qa.omniflou.com',
	cdnWidget: 'https://widget.tk.qa.omniflou.com',
	mode: 'qa',
};
